// src/modules/login/ChangePassword.js
import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom'; // useParams for token
import DashboardLayout from '../../layouts/DashboardLayout';
import Form from '../../components/shared/Form';
import Input from '../../components/shared/Input';
import Button from '../../components/shared/Button';
import { changePassword, verifyCurrentPassword } from '../auth/authService';
import styled from 'styled-components';
import { useTheme } from 'styled-components';

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${(props) => props.theme.colors.background};  /* Ensure background color */
`;

const ChangePassword = () => {
  const [currentPassword, setCurrentPassword] = useState('');  // For current password
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate(); // useNavigate replaces useHistory
  const { token } = useParams(); // useParams to get the token from URL
  const theme = useTheme();  // Access theme

  console.log("Handle Password Change");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);  // Clear previous errors
    setLoading(true);  // Start loading

    if (password !== confirmPassword) {
      setError('Passwords do not match');
      setLoading(false);
      return;
    }

    try {
      if (token) {
        // Case 1: Reset password with token
        await changePassword(token, password);
      } else {
        // Case 2: Change password with current password verification
        const isValid = await verifyCurrentPassword(currentPassword);  // Check current password
        if (!isValid) {
          setError('Current password is incorrect');
          setLoading(false);
          return;
        }
        await changePassword(null, password);  // Change password without token (user logged in)
      }
      navigate('/login');  // Redirect to login after success
    } catch (err) {
      setError('Failed to change password');
      setLoading(false);  // Stop loading on error
    }
  };

  return (
    <DashboardLayout>
      <Container>
        <Form onSubmit={handleSubmit}>
          <h2>{token ? 'Reset Password' : 'Change Password'}</h2>        
          {!token && (
            <Input
              type="password"
              placeholder="Current Password"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
            />
          )}

          <Input
            type="password"
            placeholder="New Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          
          <Input
            type="password"
            placeholder="Confirm New Password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
          />
          {error && <p style={{ color: theme.colors.error, paddingBottom: '30px', textAlign: 'center' }}>{error}</p>}
          
          <Button type="submit" disabled={loading}>
            {loading ? 'Processing...' : 'Change Password'}
          </Button>
        </Form>
      </Container>
    </DashboardLayout>
  );
};

export default ChangePassword;
